import { useCallback, useMemo } from "react";
import { useStore } from "../app/store.ts";
import {
  getSnapPieOptions,
  isSnapMenuOptionEnabled,
  runSnapMenuOption,
} from "./cursorSnapOptions.tsx";
import { useOperatorMenu } from "./hooks/useOperatorMenu.ts";
import { PieMenu, type PieMenuOption } from "./PieMenu.tsx";

export function SnapPieMenu() {
  const menu = useOperatorMenu("snapPie");
  const workspaceMode = useStore((s) => s.workspaceMode);
  const selectedObjectCount = useStore((s) => s.selectedObjectTargets.length);
  const editMode = useStore((s) => s.editMode);
  const poseMode = useStore((s) => s.poseMode);

  const { pieOptions, optionById } = useMemo(() => {
    const state = {
      workspaceMode,
      selectedObjectCount,
      editMode,
      poseMode,
    };
    const snapOptions = getSnapPieOptions(state);
    return {
      pieOptions: snapOptions.map<PieMenuOption>((option) => ({
        id: option.id,
        label: option.pieLabel,
        icon: option.renderIcon(16),
        disabled: !isSnapMenuOptionEnabled(option, state),
      })),
      optionById: new Map(snapOptions.map((option) => [option.id, option])),
    };
  }, [editMode, poseMode, selectedObjectCount, workspaceMode]);

  const handleSelect = useCallback(
    (id: string) => {
      const option = optionById.get(id);
      if (!option) {
        menu.close();
        return;
      }
      runSnapMenuOption(option);
      menu.close();
    },
    [menu, optionById],
  );

  if (pieOptions.length === 0) return null;

  return (
    <PieMenu
      open={menu.open}
      onClose={menu.close}
      onSelect={handleSelect}
      anchorPoint={menu.anchorPoint}
      options={pieOptions}
      holdKey="s"
    />
  );
}
